@if (!editing && !error) {
  <h1
    mat-dialog-title
    class="view-mode"
    [ngStyle]="viewOpacity ? { opacity: viewOpacity } : {}"
    (click)="allowEdit ? onEdit() : null">
    @if (viewHeader) {
      <div class="white-60">{{ viewHeader }}</div>
    }
    @if (headerIcon) {
      <i class="header-icon notranslate" [ngClass]="headerIcon"
         [matTooltip]="headerIconTooltip ?? ''" matTooltipPosition="above" [matTooltipShowDelay]="500"></i>
    }
    <div class="truncate-2-lines" [matTooltip]="formControl.value ?? ''" [matTooltipShowDelay]="500">
      {{ formControl.value }}
    </div>
    @if (showEditIcon) {
      <i class="material-icons notranslate edit-icon"
         role="button"
         [attr.aria-label]="editIconTooltip"
         tabindex="0"
         [matTooltip]="editIconTooltip"
         matTooltipPosition="above"
         [matTooltipShowDelay]="500"
         (click)="onEdit()"
         (keydown.enter)="onEdit()"
         (keydown.space)="onEdit()">edit</i>
    }
  </h1>
} @else {
  <div class="input-wrapper">
    <h1 mat-dialog-title class="edit-mode">
      @if (editHeader ?? viewHeader) {
        <div class="white-60">{{ editHeader ?? viewHeader }}</div>
      }
      @if (headerIcon) {
        <i class="header-icon notranslate" [ngClass]="headerIcon"
           [matTooltip]="headerIconTooltip ?? ''" matTooltipPosition="above" [matTooltipShowDelay]="500"></i>
      }
      <div class="input-container">
        <input
          type="text"
          [formControl]="formControl"
          [placeholder]="placeholder ?? ''"
          (blur)="setEditing(false)"
          (keydown.enter)="setEditing(false)"
          (keydown.tab)="setEditing(false)"
          (keydown.escape)="onCancelEdit($event)"
          #editInput
        />
        <i class="return-icon"
           role="button"
           aria-label="Confirm name"
           tabindex="0"
           matTooltip="Hit 'Enter' to confirm"
           matTooltipPosition="above"
           [matTooltipShowDelay]="500"
           (click)="setEditing(false)"
           (keydown.enter)="setEditing(false)"
           (keydown.space)="setEditing(false)">
        </i>
      </div>
    </h1>
    @if (error) {
      <p><mat-icon fontIcon="error_outline"></mat-icon>{{ error }}</p>
    }
  </div>
}
